import { render, staticRenderFns } from "./TgTree.vue?vue&type=template&id=f158f4b8"
import script from "./TgTree.vue?vue&type=script&lang=js"
export * from "./TgTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports